import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IDiscountRepository } from '../../repositories/interfaces/iDiscountRepository';
import { CSRFTokenRequest } from '../../../entity';
import {
    IGiftCardUserResubscribeReq,
    IGiftCardUserResubscribeResponseData,
} from '../../../entity/interface/iDiscounts';

export interface IGiftCardUserResubscribeUseCase {
    execute(
        payload: IGiftCardUserResubscribeReq,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: CSRFTokenRequest
    ): Promise<IGiftCardUserResubscribeResponseData>;
}

export class GiftCardUserResubscribeUseCase implements IGiftCardUserResubscribeUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get giftCardUserResub(): IDiscountRepository {
        return container.resolve<IDiscountRepository>(DI.REPOSITORIES.IDiscountRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        payload: IGiftCardUserResubscribeReq,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: CSRFTokenRequest
    ): Promise<IGiftCardUserResubscribeResponseData> {
        const response = await this.giftCardUserResub.giftCardUserResubscribe(
            payload,
            authToken,
            authSign,
            identityToken,
            csrfToken
        );
        return response.data;
    }
}
